import api from 'api'
import { CACHE_TAG_CONFIGURED_SERVICES_LIST } from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    searchConfiguredServices: build.query({
      providesTags: [CACHE_TAG_CONFIGURED_SERVICES_LIST],
      query: ({ startDate, endDate, page, size, status, upcoming, ...rest }) => ({
        url: '/api/configured-service/search',
        method: 'POST',
        body: {
          startDate,
          endDate,
          requestedPage: page,
          requestedPageSize: size,
          status,
          upcoming,
          ...rest,
        },
      }),
    }),
    getAllConfiguredServices: build.query({
      providesTags: [CACHE_TAG_CONFIGURED_SERVICES_LIST],
      query: ({ accountId = '', locationId = '', startDate, endDate, statuses }) => ({
        url: '/api/v1/core/configured-service/search',
        method: 'GET',
        params: { accountId, locationId, startDate, endDate, statuses },
      }),
    }),
  }),
})

export const { useLazySearchConfiguredServicesQuery, useLazyGetAllConfiguredServicesQuery, useGetAllConfiguredServicesQuery } = extendedApi
